import React from "react";
import { IBowser } from "bowser";
import { TransformComponent } from "react-zoom-pan-pinch";
import PrimaryImage from "~/common/MediaViewerV2/SharedComponents/ImageViewer/PrimaryImage";
import { Image } from "~/common/MediaViewerV2/model";

interface ImageMediaRendererProps {
  isMobileScreenSize: boolean;
  image: Image;
  title: string;
  openZoom: () => void;
  overlayOpen: boolean;
  bowser?: Readonly<IBowser>;
  placeholderImageUrl: string;
}

const ImageMediaRenderer = ({
  isMobileScreenSize,
  image,
  title,
  overlayOpen,
  openZoom,
  bowser,
  placeholderImageUrl,
}: ImageMediaRendererProps) => {
  return (
    <TransformComponent
      wrapperStyle={{
        overflow: "visible",
        width: "auto",
        height: "100%",
      }}
      contentStyle={{
        width: "auto",
        height: "100%",
        maxHeight: "100vh",
      }}
    >
      {isMobileScreenSize ? (
        <img
          src={`https://www.webstaurantstore.com${image.extraLarge}`}
          alt="currentImg"
          className="h-auto object-contain w-full"
        />
      ) : (
        <PrimaryImage
          src={`https://cdnimg.webstaurantstore.com/${image.extraLarge}`}
          medium={image}
          alt={title}
          overlayOpen={overlayOpen}
          openZoom={openZoom}
          isIE={bowser?.msie}
          placeholderImageUrl={placeholderImageUrl}
        />
      )}
    </TransformComponent>
  );
};

export default ImageMediaRenderer;
